import * as Yup from 'yup';
import { TFunction } from 'i18next';

export enum EmailTemplateFormFields {
    name = 'name',
    subject = 'subject',
    body = 'body',
}

export const emailTemplateSchema = (t: TFunction, requireName: boolean) => {
    return Yup.object().shape({
        [EmailTemplateFormFields.name]: requireName
            ? Yup.string().required(
                  t('settings.emailTemplates.form.errors.nameRequired')
              )
            : Yup.string().nullable().default(''),
        [EmailTemplateFormFields.subject]: Yup.string().required(
            t('settings.emailTemplates.form.errors.subjectRequired')
        ),
        [EmailTemplateFormFields.body]: Yup.string().test(
            'not-empty-html',
            t('settings.emailTemplates.form.errors.bodyRequired'),
            (value) => {
                if (!value) return false;
                const text = value.replace(/<[^>]*>/g, '').trim();
                return text.length > 0;
            }
        ),
    });
};
